import { render, staticRenderFns } from "./ItsSalesReg.vue?vue&type=template&id=074ec3d0&scoped=true&"
import script from "./ItsSalesReg.vue?vue&type=script&lang=js&"
export * from "./ItsSalesReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ec3d0",
  null
  
)

export default component.exports